/* eslint-disable no-restricted-syntax */
import { useMemo, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuthContext } from '/src/hooks';
import { showPreview } from '/src/services/web-editor';

export default function AbTestPreview() {
  const navigate = useNavigate();
  const [editorReady, setEditorReady] = useState(false);

  const { currentUser } = useAuthContext();
  const { explicitAgent } = currentUser.settings;

  const frameSrc = useMemo(() => {
    if (!window.EDITOR_PREVIEW_DATA) return null;
    return `${window.V2_WEB_EDITOR_URL}/pages/${encodeURIComponent(
      window.EDITOR_PREVIEW_DATA.url.replace(/%/g, '%25'),
    )}/blank?device=${window.EDITOR_PREVIEW_DATA.deviceType}&name=test-editor&explicit_agent=${explicitAgent}`;
  }, [explicitAgent]);

  useEffect(() => {
    const handleMessage = (event) => {
      try {
        const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

        // Listen for the editor's statusChanged: loaded signal
        if (
          data.type === 'ember-window-messenger-client' &&
          data.name === 'test-editor-events' &&
          data.query?.eventType === 'statusChanged' &&
          data.query?.payload?.status === 'loaded'
        ) {
          setEditorReady(true);
        }
        // eslint-disable-next-line no-unused-vars
      } catch (e) {
        // Ignore non-JSON messages
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  useEffect(() => {
    if (editorReady && window.EDITOR_PREVIEW_DATA) {
      showPreview(window.EDITOR_PREVIEW_DATA);
    }
  }, [editorReady]);

  if (!window.EDITOR_PREVIEW_DATA) {
    navigate('/ab-tests', { replace: true });

    return null;
  }

  return (
    <div className="wysiwyg absolute inset-0">
      <iframe
        id="test-editor-frame"
        title="Test Editor"
        src={frameSrc}
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        scrolling="no"
        frameBorder="0"
      />
    </div>
  );
}
